import iconHTML from "../assets/images/html.png";
import iconCSS from "../assets/images/css.png";
import iconJS from "../assets/images/js.png";
import iconBootstrap from "../assets/images/bootstrap.png";
import iconRedux from "../assets/images/redux.png";
import iconGit from "../assets/images/git.png";
import iconMongo from "../assets/images/mongodb.png";
import iconAntdesign from "../assets/images/antdesign.png";
import iconFirebase from "../assets/images/firebase.png";
import iconFigma from "../assets/images/figma.png";
import iconNodejs from "../assets/images/nodejs.png";

import iconReact from "../assets/images/react.png";
export const SKILLS = [
  {
    title: "HTML",
    icon: iconHTML,
  },
  {
    title: "CSS",
    icon: iconCSS,
  },
  {
    title: "JavaScript",
    icon: iconJS,
  },
  {
    title: "React.js",
    icon: iconReact,
  },
  {
    title: "Redux",
    icon: iconRedux,
  },
  {
    title: "Bootstrap",
    icon: iconBootstrap,
  },
  {
    title: "Ant Design",
    icon: iconAntdesign,
  },
  {
    title: "Git",
    icon: iconGit,
  },
  {
    title: "MongoDB",
    icon: iconMongo,
  },
  {
    title: "Firebase",
    icon: iconFirebase,
  },
  {
    title: "Figma",
    icon: iconFigma,
  },
  {
    title: "Node.js",
    icon: iconNodejs,
  },
];

export const WORK_EXPERIENCE = [
  {
    title: "Intern Web Developer at ",
    date: "May 2023 - Jul 2023",
    responsibilities: [
      "Deploying Deep Learning Models on Web Application using ReactJS.",
      "Team size: 4",
      "Technologies: React.js, Python, Flask, TensorFlow, NumPy, OpenCVs.",
    ],
  },
  {
    title: "Intern Web Developer at ",
    date: "May 2023 - Jul 2023",
    responsibilities: [
      "Deploying Deep Learning Models on Web Application using ReactJS.",
      "Team size: 4",
      "Technologies: React.js, Python, Flask, TensorFlow, NumPy, OpenCVs.",
    ],
  },
];

export const PROJECTS = [
  {
    title: "E-COMMERCE PLATFORM",
    date: "Jul 2023 - Dec 2023",
    tech: [
      {
        name: "React.js",
        color: "#4FC2F9",
      },
      {
        name: "Bootstrap",
        color: "linear-gradient(90deg, #7952b3 0%, #563D7C 100%)",
      },
      {
        name: "Python",
        color: "linear-gradient(90deg, #1D5CB5 0%, #D5B31B 100%)",
      },
      {
        name: "Node.js",
        color: "#88C249",
      },
      {
        name: "Express.js",
        color: "#303030",
      },
      {
        name: "MongoDB",
        color: "linear-gradient(90deg, #001D2A 0%, #00E661 100%)",
      },
    ],
    responsibilities: [
      "Developing a multi-store e-commerce platform using MERN Stack with Machine learning integration.",
      "Team size: 1",
      "Features:",
    ],
    features: [
      "Login, register (Google, Facebook), search and filter, cart, checkout (Paypal), order, review.",
      "Create a store, CRUD product, style, category, levels, communication, delivery, transaction, dashboard, order processing.",
    ],
    links: [
      {
        Github: "https://github.com/pqbao/e-commerce-platform",
      },
    ],
  },

  {
    title: "SNEAKER STORE WEBSITE",
    date: "Jan 2023 - May 2023",
    tech: [
      {
        name: "React.js",
        color: "#4FC2F9",
      },
      {
        name: "Redux",
        color: "#7248B6",
      },
      {
        name: "SCSS",
        color: "linear-gradient(90deg, #E9E9E9 0%, #CF649A 100%)",
      },
      {
        name: "Firebase",
        color: "linear-gradient(90deg, #FFC400 0%, #DD2C00 100%)",
      },
    ],
    responsibilities: [
      "Build a website to sell sneakers online.",
      "Team size: 1",
    ],
    features: [
      "Admin: Dashboard, CRUD product, order processing.",
      "User: Search and filter, cart, checkout (Stripe), order.",
    ],
    links: [
      {
        Github: "https://github.com/pqbao/Sneaker-Store",
        Demo: "https://sneakerdatabase-4b508.web.app/",
      },
    ],
  },
];
